"use client"

import { useBillingOverviewQuery } from "@/hooks/queries/billing-overview"
import { resolveKbUrlImportMaxPages } from "@/lib/ai/knowledge-base/url-import/constants"
import { ONBOARDING_DOCUMENT_UPLOAD_MAX_FILES } from "@/lib/onboarding/constants"
import type { SignupOnboardingKnowledgeSource } from "@/lib/onboarding/signup-onboarding"

export type OnboardingKnowledgeLimits = {
  isLoading: boolean
  maxPagesLimit: number
  maxDocumentFiles: number
  existingDocumentCount: number
  balanceDepleted: boolean
  refresh: () => Promise<void>
}

/** Shared so every variant of the knowledge step derives its limits the same way. */
export function useOnboardingKnowledgeLimits(
  knowledgeSource: SignupOnboardingKnowledgeSource,
): OnboardingKnowledgeLimits {
  const billing = useBillingOverviewQuery()

  const knowledgeBaseCount = billing.data?.counters?.knowledge_bases_count ?? 0
  const maxPagesLimit = resolveKbUrlImportMaxPages(
    billing.data?.plan?.knowledge_bases_limit,
    knowledgeBaseCount,
  )
  const existingDocumentCount = knowledgeSource === "documents" ? knowledgeBaseCount : 0

  return {
    isLoading: billing.isLoading,
    maxPagesLimit,
    existingDocumentCount,
    maxDocumentFiles: Math.min(
      existingDocumentCount + maxPagesLimit,
      ONBOARDING_DOCUMENT_UPLOAD_MAX_FILES,
    ),
    balanceDepleted: billing.data?.balance.isDepleted === true,
    refresh: billing.refresh,
  }
}
